import { render, staticRenderFns } from "./MarcaCombobox.vue?vue&type=template&id=6b467f57&scoped=true&"
import script from "./MarcaCombobox.vue?vue&type=script&lang=js&"
export * from "./MarcaCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b467f57",
  null
  
)

export default component.exports